import React from "react"
import CoreZoneLayer from "@/features/gis/CoreZoneLayer.jsx"
import { zoneValueLabel } from "@/utils/zoneLabels.js"

const rows = (p) => [
  p.name && [null, p.name],
  p.risk_type && ["Risk", zoneValueLabel(p.risk_type)],
  p.status && ["Status", zoneValueLabel(p.status)],
  p.as_of && ["As of", p.as_of],
]

export default function HighRisk(props) {
  return (
    <CoreZoneLayer
      flag="HighRisk"
      path="highrisk"
      title="High Risk Area"
      style={{ fillColor: "red", color: "red", weight: 2 }}
      rows={rows}
      {...props}
    />
  )
}
